
import { Component, Prop, State, Vue, Watch } from 'nuxt-property-decorator';
import { Site } from '@/types/initialData';
import CloseBtn from '@/components/ui/side-panel/CloseBtn.vue';
import LocalConfigStore, { BannerKey } from '@/store/localConfig.store';
import { Page } from '@/types/pageContract';
import ThemeStore from '@/store/theme.store';

@Component({
  components: { CloseBtn }
})
export default class GlobalMessage extends Vue {
  // @ts-ignore
  @State((state) => state.typo3?.initial?.site)
  site: Site;

  // @ts-ignore
  @State((state) => state.typo3?.page?.page)
  page: Page;

  @Prop({ type: Object, required: true })
  appBarHeight!: object;

  get underConstructionBannerHidden(): boolean {
    return LocalConfigStore.underConstructionBannerHidden;
  }

  get discontinuedBannerHidden(): boolean {
    return LocalConfigStore.discontinuedBannerHidden;
  }

  get bannersToHide(): Array<{ bannerType: BannerKey }> | null {
    return LocalConfigStore.bannersToHide;
  }

  get showUnderConstructionBanner(): boolean {
    return (
      !this.underConstructionBannerHidden &&
      this.page &&
      this.page.discontinued === undefined &&
      this.page.pageSettings &&
      this.page.pageSettings.messages.underConstruction !== '' &&
      !ThemeStore.appIsScrolled
    );
  }

  get underConstructionMessage(): string {
    return this.page.pageSettings.messages.underConstruction;
  }

  get backendUserActive(): number {
    return LocalConfigStore.backendUserActive;
  }

  get discontinuedHeight() {
    return {
      height: ThemeStore.appIsScrolled ? `48px` : `64px`
    };
  }

  get discontinuedActive(): boolean {
    return (
      !this.discontinuedBannerHidden && this.page && this.page!.discontinued
    );
  }

  @Watch('$route', { immediate: true })
  onRouteChange(): void {
    if (this.bannersToHide) {
      this.bannersToHide.forEach((banner) => {
        GlobalMessage.determineIfWeShowBanners(banner.bannerType);
      });
    }
  }

  closeEditModeBanner(): void {
    LocalConfigStore.setBackendUserState(0, true);
  }

  closeUnderConstructionBanner(): void {
    LocalConfigStore.underConstructionBannerHidden = true;
    LocalConfigStore.updateBannersToHide(BannerKey.UnderConstruction);
  }

  closeDiscontinuedBanner() {
    LocalConfigStore.discontinuedBannerHidden = true;
    LocalConfigStore.updateBannersToHide(BannerKey.Discontinued);
  }

  private static determineIfWeShowBanners(key: BannerKey): void {
    switch (key) {
      case BannerKey.Discontinued:
        LocalConfigStore.discontinuedBannerHidden = true;
        break;
      case BannerKey.UnderConstruction:
        LocalConfigStore.underConstructionBannerHidden = true;
        break;
      case BannerKey.BackendUser: // TODO: later on should handle backendUser here also, and prevent repeating code
        LocalConfigStore.backendUserActive = 0;
    }
  }
}
